import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  ViewEncapsulation,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { HIGHLIGHT_REQUIRED_INPUTS } from '@sc/data-access-models';

@Component({
  selector: 'sc-asterisk-info',
  styleUrls: ['./asterisk-info.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule],
  template: `
    <p>
      {{
        (highlightRequired
          ? 'GlobalApplicativeConstants.requiredFields'
          : 'GlobalApplicativeConstants.optionalFields'
        ) | translate
      }}
    </p>
  `,
})
export class AsteriskInfoComponent {
  constructor(
    @Inject(HIGHLIGHT_REQUIRED_INPUTS) public highlightRequired: boolean
  ) {}
}
